import { render, staticRenderFns } from "./user-pet-component.vue?vue&type=template&id=345b3b84&scoped=true&lang=pug"
import script from "./user-pet-component.js?vue&type=script&lang=js&external"
export * from "./user-pet-component.js?vue&type=script&lang=js&external"
import style0 from "./user-pet-component.vue?vue&type=style&index=0&id=345b3b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345b3b84",
  null
  
)

export default component.exports